module.exports = __webpack_public_path__ + "img/blue_039.da0117f0.png";